import React, {
  useEffect,
  useState,
  useRef,
  Fragment,
  useCallback,
  memo
} from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { setSolution } from "../../../store/actions/solution";
import {
  setExtendableId,
  setExtendableType,
  setExtendableSaveDisabled,
  setExtendableBackTo
} from "../../../store/actions/edit";
import {
  getCountryName,
  secondsToTime,
  secondsConvert,
  getHoursMins,
  capitalize,
  remCalc,
  addZero,
  getFormattedPhoneAndCountry,
  handleKeypress,
  validateEmail,
  isValidDurationForSelectedTime
} from "../../../utils/helpers";
import {
  setLoadingRoutesList,
  setLoadingUnscheduled,
  setLoadingStop
} from "../../../store/actions/loading";
import UnitsDialog from "./UnitsDialog";
import { setHoverStop } from "../../../store/actions/map";
import "../../../customizedLibs/phoneInput/style/style.css";

import { InputAdornment, makeStyles, Fade } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import AccountIcon from "@material-ui/icons/AccountCircle";
import AssignmentIcon from "@material-ui/icons/Assignment";
import VerifiedIcon from "@material-ui/icons/VerifiedUser";
import StarsIcon from "@material-ui/icons/Stars";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import "date-fns";
import UnsavedChangesDialog from "../../dialogs/UnsavedChangesDialog";
import FormDialog from "../../dialogs/FormDialog";
import Box from "@material-ui/core/Box";
import Panel from "../blocks/Panel";
import LoadingCircle from "../../common/LoadingCircle";
import { setInfoDialog } from "../../../store/actions/common";
import MoveToVehicle from "../blocks/MoveToVehicle";
import OptimizedTooltip from "../../common/OptimizedTooltip";
import { PhoneNumberUtil } from "google-libphonenumber";
import { saveStopChanges } from "../../../store/actions/custom";
import StatusIndicators from "./StatusIndicators";
import Form from "../../common/Form";
import { maxNoteLength } from "../../data/constants";
import mixpanelWrapper from "../../../utils/mixpanel";
import BackIcon from "@material-ui/icons/ArrowBack";

const phoneUtil = PhoneNumberUtil.getInstance();

const useStyles = makeStyles(theme => ({
  editStopWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  },
  header: {
    borderBottom: theme.variables.dividerBorder,
    minHeight: 80,
    boxSizing: "border-box",
    display: "flex",
    alignItems: "start",
    justifyContent: "space-between",
    padding: theme.spacing(1.5, 3),
    overflow: "hidden"
  },
  basicInfo: {
    width: "100%",
    alignSelf: "center",
    justifyContent: "space-between",
    display: "flex"
  },
  closeIconWrap: {
    marginRight: theme.spacing(-1),
    marginTop: theme.spacing(0.5)
  },
  inputFieldsWrapper: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 100%",
    overflow: "hidden",
    "& .Mui-disabled": {
      cursor: "not-allowed"
    }
  },
  actionButtons: {
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(1.5, 3),
    marginTop: "auto",
    "& > button:first-of-type": {
      marginRight: theme.spacing(1)
    }
  },
  switchWrapper: {
    display: "flex",
    justifyContent: "space-between"
  },
  switchInfo: {
    display: "flex",
    alignItems: "center"
  },
  quantityWrapper: {
    display: "flex",
    justifyContent: "space-between"
  },
  signatureWrapper: {
    marginTop: theme.spacing(2)
  },
  showSignature: {
    display: "flex",
    marginBottom: theme.spacing(2)
  },
  title: {
    fontSize: "1.25rem",
    lineHeight: "1.4375rem",
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
    maxWidth: "280px"
  },
  subtitle: {
    fontSize: "0.875rem",
    lineHeight: "1rem",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: "280px"
  },
  expandingPanelsPublished: {
    overflow: "auto",
    "& .MuiInputBase-input, & .MuiFormControlLabel-label": {
      color: theme.variables.rootColor
    }
  },
  requirementLabel: {
    alignItems: "flex-start",
    marginLeft: theme.spacing(-1),

    "& p:first-of-type": {
      fontSize: remCalc(15),
      lineHeight: remCalc(18),
      paddingTop: theme.spacing(1.375),
      marginBottom: theme.spacing(1.5)
    },

    "& .MuiCheckbox-root": {
      marginRight: theme.spacing(1),
      padding: theme.spacing(1),

      "&:not(.Mui-checked):hover": {
        backgroundColor: "#EEE"
      }
    }
  },
  priorityWrapper: {
    alignItems: "center",
    marginTop: theme.spacing(-1.0625)
  },
  gridContent: {
    maxWidth: "calc(100% - 48px)"
  },
  button: {
    padding: theme.spacing(1.25, 1),
    minWidth: remCalc(46),
    lineHeight: "1rem"
  },
  link: {
    fontFamily: theme.typography.body1.fontFamily,
    fontSize: "0.75rem",
    fontWeight: 500
  },
  requirementLink: {
    fontSize: remCalc(13),
    lineHeight: remCalc(15),
    fontWeight: 500,
    display: "inline-block"
  },
  mt8px: {
    marginTop: theme.spacing(1)
  },
  mb16px: {
    marginBottom: theme.spacing(2)
  },
  noteText: {
    lineHeight: remCalc(15),
    fontSize: remCalc(13),
    color: "#808080"
  },
  tooltip: {
    marginLeft: theme.spacing(1.5)
  },
  w48px: {
    width: 48
  },
  textPrimary: {
    color: theme.palette.primary.main
  },
  text11: {
    fontSize: "0.6875rem"
  },
  switchPriority: {
    marginRight: theme.spacing(-1)
  },
  noLineHeight: {
    lineHeight: 0
  }
}));

function EditStop({
  editId,
  project,
  setExtendableType,
  setExtendableId,
  stop,
  task,
  isUnassigned,
  countryCode,
  plan,
  route,
  setInfoDialog,
  routeGroups,
  setHoverStop,
  loadingRoutesList,
  saveStopChanges,
  setExtendableSaveDisabled,
  saveDisabled,
  setLoadingStop,
  tags,
  sortedTags,
  loading,
  backTo,
  setExtendableBackTo
}) {
  const inputRef = useRef();
  let routeLocked = route.locked;
  let routeInProgress = route.status === "in_progress";

  const classes = useStyles();
  const [expanded, setExpanded] = useState(0);
  const [unitsDialog, setUnitsDialog] = useState(false);
  const [changesDialog, setChangesDialog] = useState(false);
  const [isTimeWindowSet, setTimeWindowSet] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const hideDetails = routeInProgress && !plan.ft_live_status_updates;

  // apply published state restrictions also on locked routes, finished stops, adjust live routes limitation
  const published =
    ["published", "finished", "expired"].includes(
      project.status.toLowerCase()
    ) ||
    routeLocked ||
    (routeInProgress && !(plan && plan.ft_adjust_live_routes));

  const isTaskSkippedOrFinished =
    task && (task.status === "finished" || task.status === "skipped");

  const [inputValues, setInputValues] = useState({
    name: "",
    phoneNumber: "",
    phoneCountry: "",
    email: "",
    deliveryStart: new Date().setHours(0, 0),
    deliveryEnd: new Date().setHours(23, 59),
    duration: "",
    load: null,
    units: [],
    type: "delivery",
    notes: "",
    checkboxSignature: false,
    checkboxBarcode: false,
    checkboxPhoto: false,
    checkboxAge: false,
    highPriority: false,
    vehicle: route?.vehicle_name
  });

  const [errors, setErrors] = useState({
    email: "",
    deliveryStart: "",
    deliveryEnd: "",
    duration: "",
    load: ""
  });

  const [panelErrors, setPanelErrors] = useState({
    0: 0,
    1: 0
  });

  // Form dialog state
  const [noteValue, setNoteValue] = useState("");

  useEffect(() => {
    if (inputValues.notes) setNoteValue(inputValues.notes);
  }, [inputValues.notes, dialogOpen]);

  useEffect(() => {
    const { deliveryStart, deliveryEnd, duration } = inputValues;
    if (
      duration &&
      !isValidDurationForSelectedTime(deliveryStart, deliveryEnd, duration)
    ) {
      setErrors({
        ...errors,
        duration:
          "Stop duration shouldn't be longer than the delivery time window"
      });
      setExtendableSaveDisabled(true);
    } else {
      if (errors.duration) setErrors({ ...errors, duration: "" });
    }
  }, [
    inputValues?.duration,
    inputValues?.deliveryStart,
    inputValues?.deliveryEnd
  ]);

  // Handle input fields changes
  const handleChange = e => {
    const { name, value } = e.target;
    setInputValues({ ...inputValues, [name]: value });
    if (String(value).trim() !== String(inputValues[name]).trim()) {
      setExtendableSaveDisabled(false);
    }
  };

  // Handle max number check on keyUp
  const handleKeyup = e => {
    const { name, value, max } = e.target;
    setInputValues({
      ...inputValues,
      [name]: max && value > Number(max) ? max : value
    });
  };

  const handlePhoneChange = (val, country) => {
    setInputValues({
      ...inputValues,
      phoneNumber: val,
      phoneCountry: country && country.dialCode
    });

    if (
      val.trim() !== country?.dialCode ||
      val.trim() !== inputValues.phoneNumber.trim()
    ) {
      setExtendableSaveDisabled(false);
    }
  };

  // Handle time input change
  const handleTimeChange = (val, name) => {
    setInputValues({
      ...inputValues,
      [name]: val
    });
    setTimeWindowSet(true);
    setExtendableSaveDisabled(false);
  };

  const birthday =
    task &&
    task.recipient_date_of_birth &&
    new Date(task.recipient_date_of_birth);
  const birthday_string = birthday
    ? `${birthday.getFullYear()}-${addZero(birthday.getMonth() + 1)}-${addZero(
        birthday.getDate()
      )}`
    : "";

  // Handle time input blur
  const isValid = (name, defaultVal) => {
    if (!inputValues[name]) {
      setInputValues({ ...inputValues, [name]: defaultVal });
      setErrors({ ...errors, startTime: "", [name]: "" });
      return false;
    }
    if (inputValues[name].toString() === "Invalid Date") {
      setErrors({ ...errors, [name]: "Invalid time format" });
      return false;
    }
    setErrors(state => ({
      ...state,
      [name]: ""
    }));
    return true;
  };

  const timeBetween = (start, end) => {
    if (
      inputValues[start]?.toString() !== "Invalid Date" &&
      inputValues[end]?.toString() !== "Invalid Date"
    )
      return setErrors(state => ({
        ...state,
        [start]:
          state[start] === "Invalid time format"
            ? state[start]
            : getHoursMins(inputValues[end]) <= getHoursMins(inputValues[start])
            ? "Invalid time window"
            : ""
      }));
  };

  const checkLimitation = name => {
    if (name === "checkboxSignature" && plan && plan.ft_signature_collection)
      return true;
    if (name === "checkboxPhoto" && plan && plan.ft_age_verification)
      return true;
    if (name === "checkboxAge" && plan && plan.ft_photo_collection) return true;
    return false;
  };

  // Check plan limitations on POD requirements
  const handleCheckboxChange = e => {
    if (e.target.name === "highPriority" || checkLimitation(e.target.name)) {
      setInputValues({ ...inputValues, [e.target.name]: e.target.checked });
      if (e.target.checked) {
        mixpanelWrapper.track("POD Requirements Add", {
          Requirements: [
            (inputValues.checkboxSignature ||
              e.target.name === "checkboxSignature") &&
              "Signature",
            (inputValues.checkboxPhoto || e.target.name === "checkboxPhoto") &&
              "Photo",
            (inputValues.checkboxAge || e.target.name === "checkboxAge") &&
              "Age verification"
          ]
            .filter(Boolean)
            .join(", ")
        });
      }
      setExtendableSaveDisabled(false);
    } else {
      setInfoDialog({
        visible: true,
        title: "Action not allowed",
        body: "Please upgrade your plan"
      });
    }
  };

  // Handle expand/collapse
  const handlePanelChange = useCallback(
    index => setExpanded(expanded === index ? null : index),
    [expanded, setExpanded]
  );

  const openPanelOnTab = (e, index, reverse) => {
    if (
      e.keyCode === 9 &&
      ((reverse && e.shiftKey) || (!e.shiftKey && !reverse))
    ) {
      setExpanded(index);
    }
  };

  // Close edit panel
  const handleClose = () => {
    setExtendableType(backTo || null);
    setExtendableBackTo(null);
    setExtendableId(null);
    setHoverStop(null);
  };

  // Warn before closing
  const warnClose = saveDisabled ? handleClose : () => setChangesDialog(true);

  // Set units
  const setUnits = useCallback(
    (units, changeSave) => {
      setInputValues({
        ...inputValues,
        units,
        load:
          units.reduce((prev, current) => {
            return prev + (current.quantity || 0);
          }, 0) || ""
      });

      changeSave && setExtendableSaveDisabled(false);
    },
    [inputValues, setExtendableSaveDisabled]
  );

  // Validate inputs and call save function
  const handleSave = isFormDialog => {
    const {
      email,
      deliveryStart,
      deliveryEnd,
      duration,
      load,
      phoneNumber,
      notes
    } = inputValues;

    const errors = {
      email: "",
      deliveryStart: "",
      deliveryEnd: "",
      duration: "",
      load: "",
      phone: "",
      notes: ""
    };

    const errorQueue = [];

    let contactErrors = 0;
    let taskErrors = 0;

    // Validate inputs
    const { numberVal } = getFormattedPhoneAndCountry(
      inputValues.phoneNumber || ""
    );
    if (numberVal.length && numberVal !== inputValues.phoneCountry) {
      const number =
        numberVal.length > 4 &&
        (phoneNumber.includes("+")
          ? phoneUtil.parseAndKeepRawInput(phoneNumber)
          : phoneUtil.parseAndKeepRawInput("+" + inputValues.phoneNumber));
      if (!number || !phoneUtil.isValidNumber(number)) {
        errors.phoneNumber = "Please enter a valid phone number";
        errorQueue.push(0);
      }
    }

    if (email && !validateEmail(email)) {
      errors.email = "Invalid email";

      contactErrors++;
      errorQueue.push(0);
    }
    // When duraton and it is not a number
    if (duration && !Number.isInteger(+duration)) {
      errors.duration = "Duration should be a number";

      taskErrors++;
      errorQueue.push(1);
    }
    if (duration && Number.isInteger(+duration) && Number(+duration) < 0) {
      errors.duration = "Duration should be a positive number";

      taskErrors++;
      errorQueue.push(1);
    }

    if (load && (!Number.isInteger(+load) || Number(load) < 0)) {
      errors.load = "Load should be non negative number";

      taskErrors++;
      errorQueue.push(1);
    }
    if (deliveryStart >= deliveryEnd) {
      errors.deliveryStart = "Invalid time window";
      taskErrors++;
      errorQueue.push(1);
    }
    if (
      deliveryStart !== undefined &&
      deliveryStart !== null &&
      deliveryStart.toString() === "Invalid Date"
    ) {
      errors.deliveryStart = "Invalid time format";

      taskErrors++;
      errorQueue.push(1);
    }
    if (
      deliveryEnd !== undefined &&
      deliveryEnd !== null &&
      deliveryEnd.toString() === "Invalid Date"
    ) {
      errors.deliveryEnd = "Invalid time format";

      taskErrors++;
      errorQueue.push(1);
    }

    if (notes && notes.length >= 2500) {
      errors.notes =
        "Delivery note characters count can not be greater than 2500 characters";

      taskErrors++;
      errorQueue.push(1);
    }

    if (load && +load > 999999999) {
      errors.load = "Loads can not be more than 99999999";

      taskErrors++;
      errorQueue.push(1);
    }

    const errorsStr = Object.keys(errors).reduce(
      (sum, el) => sum + errors[el],
      ""
    );

    if (!errorsStr)
      saveStopChanges(
        stop,
        {
          ...inputValues,
          tags: tags.filter(tag => selectedTags.includes(tag.id)),
          notes: isFormDialog ? noteValue : inputValues.notes
        },
        isUnassigned,
        isTimeWindowSet,
        route.id
      );
    else setExpanded(errorQueue[0]);

    setErrors(errors);
    setPanelErrors({ 0: contactErrors, 1: taskErrors });
  };

  // Summary texts
  const getSummary = array => {
    return array.some(el => el)
      ? array
          .reduce((sum, val) => {
            if (val === "phoneNumber") {
              return (
                sum +
                (inputValues[val]
                  ? `, ${"+" + inputValues[val].split("+").join("")}`
                  : "")
              );
            } else {
              return sum + (inputValues[val] ? `, ${inputValues[val]}` : "");
            }
          }, "")
          .slice(2)
      : null;
  };

  const contactSummary = () => getSummary(["name", "phoneNumber", "email"]);
  const taskSummary = () => {
    const { deliveryStart, deliveryEnd, duration, load, type, notes } =
      inputValues;
    let str = "";

    published &&
      task &&
      task.original_arr_time &&
      (str += `, Planned ETA ${secondsToTime(task.original_arr_time)}`);
    type && (str += `, ${capitalize(type)}`);
    deliveryStart &&
      deliveryEnd &&
      (str += `, ${getHoursMins(deliveryStart)}-${getHoursMins(deliveryEnd)}`);
    duration && (str += `, ${duration} Min`);
    load && (str += `, ${load} Unit${load > 1 ? "s" : ""}`);
    notes && (str += `, ${notes}`);
    return str.slice(2);
  };

  const requirementsSummary = () => {
    let str = "";

    inputValues.checkboxSignature && (str += ", Signature");
    inputValues.checkboxBarcode && (str += ", Barcode");
    inputValues.checkboxPhoto && (str += ", Photo");
    inputValues.checkboxAge && (str += ", Age verification");

    return str.slice(2);
  };

  const unitsQuantity = inputValues.units.filter(
    unit => unit.name + unit.barcode + unit.note
  ).length;

  // Clear panel errors if expanded
  useEffect(() => {
    if (expanded !== null) setPanelErrors({ ...panelErrors, [expanded]: 0 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded]);

  const generateInputValues = stop => ({
    name: stop.information.recipient_name || "",
    phoneNumber: stop.information.recipient_phone
      ? "+" + stop.information.recipient_phone
      : "",
    email: stop.information.email || "",
    deliveryStart:
      stop.time_windows && stop.time_windows.length
        ? secondsConvert(stop.time_windows[0].earliest)
        : new Date().setHours(0, 0),
    deliveryEnd:
      stop.time_windows && stop.time_windows.length
        ? secondsConvert(stop.time_windows[0].latest)
        : new Date().setHours(23, 59),
    duration:
      stop.duration >= 0 && stop.duration !== null ? `${stop.duration}` : "",
    load: stop.units?.length
      ? stop.units.reduce((acc, val) => acc + (val.quantity || 0), 0) || ""
      : null,
    units: stop.units || [],
    type: stop.type || "delivery",
    notes: stop.information.notes || "",
    checkboxSignature:
      (stop.requirements && stop.requirements.signature) || false,
    checkboxBarcode: (stop.requirements && stop.requirements.barcode) || false,
    checkboxPhoto: (stop.requirements && stop.requirements.picture) || false,
    checkboxAge:
      (stop.requirements && stop.requirements.age_verification) || false,
    highPriority: stop.priority === 1,
    tags: stop.tags
  });

  // Extract stop info and fill inputs
  useEffect(() => {
    if (stop) {
      // const tagIds = tags.map(tag=>tag.id);
      setSelectedTags(
        stop.tags
          ? stop.tags
              .filter(currentTag => tags.find(tag => tag.id === currentTag.id))
              .map(tag => tag.id)
          : []
      );
      setInputValues(generateInputValues(stop));
    }

    setErrors({
      email: "",
      deliveryStart: "",
      deliveryEnd: "",
      duration: "",
      load: ""
    });

    // Clear form dialog state
    if (noteValue) setNoteValue("");

    // Focus on first input
    !noteValue && setExpanded(0);
    const element = inputRef.current;
    setTimeout(() => element?.querySelector("input").focus(), 200);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stop]);

  const taskStatus = task ? task.status : "";
  useEffect(() => {
    stop && setInputValues(generateInputValues(stop));

    setExtendableSaveDisabled(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskStatus]);

  const [selectedTags, setSelectedTags] = useState([]);

  const handleTagSelect = tag => {
    if (selectedTags.includes(tag.id)) {
      setSelectedTags(
        selectedTags.filter(selectedTag => selectedTag !== tag.id)
      );
    } else {
      setSelectedTags([...selectedTags, tag.id]);
    }
    setExtendableSaveDisabled(false);
  };

  if (!editId) return <></>;

  return (
    <form className={classes.editStopWrapper}>
      <Fade in={loading} mountOnEnter unmountOnExit>
        <LoadingCircle hideCircle={loadingRoutesList} />
      </Fade>
      {/* Header */}
      <div className={classes.header}>
        {(backTo || routeLocked || published) && (
          <Box mr={3} mt={0.5}>
            <OptimizedTooltip placement="bottom" title="Close">
              <IconButton onClick={warnClose}>
                {published || routeLocked ? <CloseIcon /> : <BackIcon />}
              </IconButton>
            </OptimizedTooltip>
          </Box>
        )}
        <div className={classes.basicInfo}>
          <div style={{ overflow: "hidden" }}>
            <Typography
              className={classes.title}
              variant="h5"
              noWrap
              id="editStop-streetTitle"
            >
              {stop.information.street ? (
                <>{(stop.information && stop.information.street) || ""}</>
              ) : stop.information.recipient_name ? (
                stop.information.recipient_name
              ) : (
                `${stop.address.lat}, ${stop.address.lng}`
              )}
            </Typography>

            <Typography
              className={classes.subtitle}
              color="secondary"
              id={"editStops-postalDetails"}
            >
              {(stop.information &&
                stop.information.street &&
                stop.information.zipcode) ||
                ""}{" "}
              {(stop.information && stop.information.city) || ""}
              {(stop.information.city && stop.information.country ? ", " : "") +
                (stop.information.country
                  ? getCountryName(stop.information.country)
                  : "")}
            </Typography>
          </div>

          {project.solution && !published && (
            <MoveToVehicle
              routeGroups={routeGroups}
              isUnassigned={isUnassigned}
              routeId={route.id}
              editId={[editId]}
              setLoadingStop={setLoadingStop}
            />
          )}
        </div>
        {/*
        {published && (
          <OptimizedTooltip placement="bottom" title="Close">
            <div className={classes.closeIconWrap}>
              <IconButton onClick={warnClose}>
                <CloseIcon />
              </IconButton>
            </div>
          </OptimizedTooltip>
        )}*/}
      </div>

      <div className={classes.inputFieldsWrapper}>
        {/* Status chips */}
        {published &&
          task &&
          (task.status === "finished" || task.status === "skipped") &&
          !hideDetails && <StatusIndicators task={task} />}

        {/* Expanding panels */}
        <Box
          overflow="auto"
          key={stop.id}
          className={classes.expandingPanelsPublished}
          py={4}
          pl={4}
          pr={5}
        >
          {/* Contact details */}
          <Panel
            panelChange={() => handlePanelChange(0)}
            expanded={expanded === 0}
            id="editStop-contactDetailsExpand"
            title="Contact details"
            summary={contactSummary()}
            published={published}
            icon={
              <AccountIcon
                className={clsx({ [classes.textPrimary]: expanded === 0 })}
              />
            }
            error={panelErrors[0]}
          >
            <Grid container spacing={1}>
              <Grid className={classes.w48px} item xs="auto" />

              {/* Name */}
              <Grid item xs className={classes.gridContent}>
                <Form
                  data={[
                    [
                      {
                        renderInputField: true,
                        label: "Name",
                        name: "name",
                        type: "text",
                        autoFocus: true,
                        disabled: published,
                        ref: true,
                        topMargin: true,
                        dataCy: "editStop-recipientName"
                      }
                    ],
                    [
                      {
                        label: "Mobile phone",
                        name: "phoneNumber",
                        componentType: "phone",
                        dataCy: "editStop-recipientPhone"
                      }
                    ],
                    [
                      {
                        renderInputField: true,
                        label: "Email",
                        name: "email",
                        type: "email",
                        disabled: published,
                        onKeyDown: e => openPanelOnTab(e, 1),
                        dataCy: "editStop-recipientEmail"
                      }
                    ]
                  ]}
                  editStop
                  inputValues={inputValues}
                  handleChange={handleChange}
                  handlePhoneChange={handlePhoneChange}
                  errorValues={errors}
                  published={published}
                  countryCode={countryCode}
                  inputRef={inputRef}
                />
              </Grid>
            </Grid>
          </Panel>

          {/* Task details */}
          <Panel
            panelChange={() => handlePanelChange(1)}
            expanded={expanded === 1}
            id="editStop-taskDetailsExpand"
            title="Task details"
            summary={taskSummary()}
            published={published}
            icon={
              <AssignmentIcon
                className={clsx({ [classes.textPrimary]: expanded === 1 })}
              />
            }
            error={panelErrors[1]}
          >
            <Grid container spacing={1}>
              <Grid className={classes.w48px} item xs="auto" />

              <Grid item xs className={classes.gridContent}>
                {/* Form */}
                <Form
                  data={[
                    [
                      {
                        renderInputField: published && task,
                        label: "Planned ETA",
                        value: task?.original_arr_time
                          ? secondsToTime(task?.original_arr_time)
                          : "",
                        disabled: true,
                        topMargin: true,
                        endAdornment: (
                          <InputAdornment position="end">Hours</InputAdornment>
                        )
                      }
                    ],
                    [
                      {
                        labelId: "select-type-label",
                        selectId: "select-type",
                        name: "type",
                        label: "Type",
                        dataCy: "stop-type",
                        shrink: true,
                        topMargin: !published,
                        disabled: published,
                        onKeyDown: e => openPanelOnTab(e, 0, true),
                        onChange: e => handleChange(e),
                        options: [
                          ["delivery", "Delivery"],
                          ["pickup", "Pickup"]
                        ],
                        componentType: "select"
                      }
                    ],
                    [
                      {
                        startLabel: "Deliver between",
                        endLabel: "And",
                        startName: "deliveryStart",
                        endName: "deliveryEnd",
                        startDataCy: "stop-from",
                        endDataCy: "stop-to",
                        onBlurStart: () => {
                          isValid("deliveryStart", new Date().setHours(0, 0)) &&
                            timeBetween("deliveryStart", "deliveryEnd");
                        },
                        onBlurEnd: () => {
                          isValid("deliveryEnd", new Date().setHours(23, 59)) &&
                            timeBetween("deliveryStart", "deliveryEnd");
                        },
                        onChangeStart: val =>
                          handleTimeChange(val, "deliveryStart"),
                        onChangeEnd: val =>
                          handleTimeChange(val, "deliveryEnd"),
                        disabled: published,
                        componentType: "timeWindow"
                      }
                    ],
                    [
                      {
                        renderInputField: true,
                        label: "Duration",
                        name: "duration",
                        type: "number",
                        min: 0,
                        max: 1440,
                        disabled: published,
                        onKeyDown: e => handleKeypress(e),
                        onKeyUp: e => handleKeyup(e),
                        dataCy: "stop-duration",
                        endAdornment: (
                          <InputAdornment position="end">Min.</InputAdornment>
                        )
                      }
                    ],
                    [
                      {
                        renderInputField: true,
                        label: "Load",
                        name: "load",
                        disabled:
                          unitsQuantity > 0 ||
                          published ||
                          inputValues.units.length > 1,
                        dataCy: "stop-load",
                        endAdornment: (
                          <InputAdornment position="end">Units</InputAdornment>
                        ),
                        helperText: (
                          <div className={classes.quantityWrapper}>
                            <Typography
                              color="secondary"
                              className={classes.text11}
                            >
                              {(unitsQuantity ||
                                inputValues.units.length > 1) &&
                              !published
                                ? "Want to edit? Click on more details."
                                : ""}
                            </Typography>
                            <Link
                              className={classes.link}
                              onClick={() => setUnitsDialog(true)}
                              underline="none"
                              color={
                                inputValues.load ? "primary" : "textSecondary"
                              }
                              component="button"
                              type="button"
                              disabled={!inputValues.load}
                              id="editStop_loadDetails"
                            >
                              More details
                            </Link>
                          </div>
                        )
                      }
                    ],
                    [
                      {
                        renderInputField: true,
                        label: "Delivery note",
                        name: "notes",
                        readOnly: published,
                        multiline: true,
                        disabled: published,
                        dataCy: "stop-note",
                        error: inputValues.notes.length >= maxNoteLength,
                        // onClick: () => published && setDialogOpen(true),
                        onChange: e =>
                          (e.target.value = e.target.value.slice(
                            0,
                            maxNoteLength
                          )),
                        onKeyDown: e => openPanelOnTab(e, 2),
                        helperText: (
                          <span
                            style={{
                              display: "flex",
                              component: "span",
                              justifyContent: "space-between"
                            }}
                          >
                            <span>
                              {inputValues.notes.length >= maxNoteLength &&
                                `Maximum allowed note length is ${maxNoteLength}`}
                            </span>
                            <span>{`${inputValues.notes.length}/${maxNoteLength}`}</span>
                          </span>
                        )
                      }
                    ],
                    [
                      {
                        labelId: "tag-vehicle",
                        selectId: "tag-vehicle-select",
                        label: "Tags",
                        name: "tag",
                        type: "stop",
                        choose: false,
                        disabled: published,
                        options: sortedTags,
                        // shrink: true,
                        selected: selectedTags,
                        // dataCy: "tag-select-type",
                        onChange: handleTagSelect,
                        componentType: "tagSelect"
                      }
                    ]
                  ]}
                  editStop
                  inputValues={inputValues}
                  errorValues={errors}
                  handleChange={handleChange}
                  handlePhoneChange={handlePhoneChange}
                />
              </Grid>
            </Grid>
          </Panel>

          {/* Requirements */}
          <Panel
            panelChange={() => handlePanelChange(2)}
            expanded={expanded === 2}
            id="editStop-requirementsExpand"
            title="Requirements"
            summary={requirementsSummary()}
            published={published}
            icon={
              <VerifiedIcon
                className={clsx({ [classes.textPrimary]: expanded === 2 })}
              />
            }
            error={panelErrors[2]}
          >
            <Grid container spacing={1}>
              <Grid className={classes.w48px} item xs="auto" />

              {/* Name */}
              <Grid item xs className={classes.gridContent}>
                <Typography className={clsx(classes.noteText, classes.mt8px)}>
                  If nothing is ticked, the driver will not be obligated collect
                  any proof of delivery
                </Typography>

                {/* Signature */}
                <div className={classes.signatureWrapper}>
                  <FormControlLabel
                    className={classes.requirementLabel}
                    control={
                      <Checkbox
                        color="primary"
                        name="checkboxSignature"
                        checked={inputValues.checkboxSignature}
                        value="signature"
                        onChange={handleCheckboxChange}
                        onKeyDown={e => openPanelOnTab(e, 1, true)}
                      />
                    }
                    label={
                      <>
                        <Typography>Signature</Typography>

                        {published && task && task.signature && (
                          <div className={classes.showSignature}>
                            <Link
                              href={task.signature}
                              target="_blank"
                              rel="noopener noreferrer"
                              color="primary"
                              className={classes.requirementLink}
                            >
                              View signature{" "}
                            </Link>
                            {task.signature_name && (
                              <>
                                <span
                                  style={{
                                    padding: "0 4px",
                                    lineHeight: "15px"
                                  }}
                                >
                                  |
                                </span>
                                <Typography
                                  className={classes.noteText}
                                  component="span"
                                  style={{ lineHeight: "15px", paddingTop: 0 }}
                                >
                                  Signed by {task.signature_name}
                                </Typography>
                              </>
                            )}
                          </div>
                        )}
                      </>
                    }
                    disabled={published}
                  />
                </div>

                {/* Barcode (keep for future)*/}
                {/*<Box>*/}
                {/*  <FormControlLabel*/}
                {/*    className={classes.requirementLabel}*/}
                {/*    control={*/}
                {/*      <Checkbox*/}
                {/*        color="primary"*/}
                {/*        name="checkboxBarcode"*/}
                {/*        checked={inputValues.checkboxBarcode}*/}
                {/*        value="barcode"*/}
                {/*        onChange={handleCheckboxChange}*/}
                {/*      />*/}
                {/*    }*/}
                {/*    label={*/}
                {/*      <>*/}
                {/*        <Typography>Barcode capture</Typography>*/}
                {/*      </>*/}
                {/*    }*/}
                {/*    disabled={published}*/}
                {/*  />*/}
                {/*</Box>*/}

                {/* Age verification */}
                <div>
                  <FormControlLabel
                    className={classes.requirementLabel}
                    control={
                      <Checkbox
                        color="primary"
                        name="checkboxAge"
                        checked={inputValues.checkboxAge}
                        value="signature"
                        onChange={handleCheckboxChange}
                      />
                    }
                    label={
                      <>
                        <Typography>Age verification</Typography>

                        {published && task && task.age_verified && (
                          <Typography
                            className={clsx(classes.mb16px, classes.noteText)}
                          >
                            Age successfully verified ({birthday_string})
                          </Typography>
                        )}
                      </>
                    }
                    disabled={published}
                  />
                </div>

                {/* Photo */}
                <div>
                  <FormControlLabel
                    className={classes.requirementLabel}
                    control={
                      <Checkbox
                        color="primary"
                        name="checkboxPhoto"
                        checked={inputValues.checkboxPhoto}
                        value="signature"
                        onChange={handleCheckboxChange}
                      />
                    }
                    label={
                      <div className={classes.noLineHeight}>
                        <Typography>Photo</Typography>

                        {published &&
                          task &&
                          task.images &&
                          task.images.map((image, i) => (
                            <Fragment key={i}>
                              {i > 0 && (
                                <span
                                  style={{
                                    display: "inline-block",
                                    lineHeight: "15px",
                                    margin: "0 8px"
                                  }}
                                >
                                  |
                                </span>
                              )}

                              <Link
                                href={image}
                                target="_blank"
                                rel="noopener noreferrer"
                                color="primary"
                                className={clsx(
                                  classes.mb16px,
                                  classes.requirementLink
                                )}
                              >
                                View photo {i + 1}
                              </Link>
                            </Fragment>
                          ))}
                      </div>
                    }
                    disabled={published}
                  />
                </div>
              </Grid>
            </Grid>
          </Panel>

          {/* Priority */}
          <Grid className={classes.priorityWrapper} container spacing={1}>
            <Grid component={Grid} className={classes.w48px} item xs="auto">
              <StarsIcon />
            </Grid>

            {/* Switch */}
            <Grid component={Grid} className={classes.switchWrapper} item xs>
              <div className={classes.switchInfo}>
                <Typography variant="body1">Priority</Typography>
              </div>

              <Switch
                name="highPriority"
                id="editStops-prioritySwitch"
                onChange={handleCheckboxChange}
                className={classes.switchPriority}
                checked={inputValues.highPriority}
                color="primary"
                inputProps={{ "aria-label": "primary checkbox" }}
                disabled={published}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Action buttons */}
        {!published && (
          <div className={classes.actionButtons}>
            <Button
              className={classes.button}
              color="primary"
              onClick={warnClose}
              data-cy="cancelStopUpdate"
            >
              Cancel
            </Button>

            <Button
              className={classes.button}
              color="primary"
              onClick={() => handleSave()}
              disabled={saveDisabled}
              data-cy="saveStopUpdate"
            >
              Save
            </Button>
          </div>
        )}
      </div>

      {/* Unsaved changes dialog */}
      <UnsavedChangesDialog
        open={changesDialog}
        handleClose={() => setChangesDialog(false)}
        action={handleClose}
      />

      {/* Delivery note form dialog
      <FormDialog
        type="text"
        title="Edit delivery note"
        label="Delivery note"
        dataCy="deliveryNote"
        confirmText="Save"
        value={noteValue}
        setValue={setNoteValue}
        open={dialogOpen}
        action={e => {
          console.log(stop)
          e.preventDefault();
          setDialogOpen(false);
          handleSave(true);
        }}
        handleClose={() => setDialogOpen(false)}
      />
*/}
      {/* Dialog */}
      <UnitsDialog
        open={unitsDialog}
        setUnitsDialog={setUnitsDialog}
        load={inputValues.load}
        taskStatus={taskStatus}
        units={inputValues.units}
        setUnits={setUnits}
        stopId={stop.id}
        isDisabledToEdit={isTaskSkippedOrFinished || published}
      />
    </form>
  );
}

const stopPropsAreEqual = function (prevProps, nextProps) {
  if (
    prevProps.saveDisabled === nextProps.saveDisabled &&
    prevProps.stop.id === nextProps?.stop?.id &&
    prevProps.task?.status === nextProps.task?.status &&
    prevProps.stop.information.notes === nextProps?.stop?.information.notes &&
    prevProps.loading === nextProps?.loading &&
    prevProps?.route?.locked === nextProps?.route?.locked
  ) {
    return true;
  }
};

function mapStateToProps(state) {
  // Stop from vrp

  const stop = state.project.vrp.stops.find(
    el => el.id === state.extendable.id
  );

  let task = null;
  let stopRoute = {};
  let routesInfo =
    (state.project.solution && state.project.solution.routeGroups) || [];

  // Stop and route from solution
  stop &&
    state.project.solution &&
    state.project.solution.routes.find(route =>
      route?.stops?.forEach(
        el => el.id === stop.id && ((task = el), (stopRoute = route))
      )
    );

  let countryCode;
  const organisationSite = state.auth.userData.organisationSite;
  if (organisationSite && organisationSite.organisation) {
    countryCode = organisationSite.organisation.country;
  }

  return {
    editId: state.extendable.id,
    backTo: state.extendable.backTo,
    project: state.project,
    stop,
    task,
    isUnassigned:
      state.project.solution &&
      state.project.solution.unassigned.stops.findIndex(
        el => state.extendable.id === el.id
      ) > -1,
    route: stopRoute,
    routeGroups: routesInfo,
    countryCode: countryCode || state.auth.userData.countryName,
    saveDisabled: state.extendable.saveDisabled,
    plan:
      (state.auth.userData.organisationSite &&
        state.auth.userData.organisationSite.organisation.plan) ||
      {},
    loading: state.loading.editStop,
    sortedTags: state.account.sortedTags,
    tags: state.account.tags,
    loadingRoutesList: state.loading.routesList
  };
}

export default connect(mapStateToProps, {
  setSolution,
  setExtendableType,
  setExtendableId,
  setLoadingRoutesList,
  setLoadingUnscheduled,
  setHoverStop,
  setLoadingStop,
  setInfoDialog,
  saveStopChanges,
  setExtendableSaveDisabled,
  setExtendableBackTo
})(memo(EditStop, stopPropsAreEqual));
